// state
const state = {
  refineryRadarName: "",
  dataRadar: {},
};

const getters = {
  getDataRadar(state) {
    return state.dataRadar;
  },
  getRadarName(state) {
    return state.refineryRadarName;
  },
};

const actions = {
  // action
  setRadarName(context, data) {
    context.commit("SET_RADAR_NAME", data);
  },
};

const mutations = {
  // mutations
  SET_RADAR_NAME(state, data) {
    state.refineryRadarName = data;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
